import React from "react";
import { Link } from "react-router-dom";
import TimeAgo from "react-timeago";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { MEDIA_URL } from "../../../configs";

dayjs.extend(relativeTime);

const RecentUsersList = ({ recentUsersData }) => (
  <div className="p-4 shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-3">
      <strong>Recent Registered Users</strong>
      <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
      </span>
    </div>
    {recentUsersData && recentUsersData.length > 0 ? (
      <ul className="list-unstyled">
        {recentUsersData.map((user, index) => (
          <li
            className="mb-2 d-flex justify-content-start align-items-center"
            key={index}
          >
            <div className="avatar">
              {user.avatar ? (
                <img
                  className="rounded-circle"
                  src={`${MEDIA_URL}${user.avatar}`}
                  width={32}
                  alt="User Avatar"
                />
              ) : (
                <div
                  className="d-flex border mx-auto align-items-center justify-content-center rounded-circle bg-light text-secondary p-2"
                  style={{ width: 32, height: 32 }}
                >
                  <i className="bi bi-person-fill"></i>
                </div>
              )}
            </div>
            <div className="ms-4">
              <p className="mb-1 small">
                <Link to={`/users/view/${user._id}`} className="text-dark">
                  {user.username || "Unknown User"}
                </Link>
              </p>
              <div>
                <span className="small text-muted me-2">
                  {dayjs(user.created_at).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              
                <div className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="text-break">
                      <TimeAgo date={user.created_at} />
                    </span>
                </div>
                </div>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted small">No recent users found.</p>
    )}
  </div>
);

export default RecentUsersList;
